import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./DateSelect.module.css";
import { useTranslation } from "react-i18next";

export function DateSelect({
  label,
  img,
  onDateChange,
  expDate,
  className,
  isValid,
  disabled,
}) {
  const [date, setDate] = useState("");
  const {t} = useTranslation();

  useEffect(() => {
    if (disabled && expDate) {
      const [month, year] = expDate.split("/");
      setDate(`${month}/${year.slice(-2)}`);
    } else {
      setDate(expDate || "");
    }
  }, [disabled, expDate]);

  const handleChange = (e) => {
    const value = e.target.value;
    if (/^\d{0,2}\/?\d{0,2}$/.test(value)) {
      setDate(value);
      if (value.length === 5) {
        const [month, year] = value.split("/");
        if (month && year) {
          onDateChange({ month, year: `20${year}` });
        }
      }
    }
  };

  const containerClass = classNames({
    [styles.containerValid]: isValid,
    [styles.containerDefault]: isValid === null,
    [styles.containerError]: isValid === false,
    [styles.container]: true,
  });

  const inputClass = classNames(styles.input, className, {
    [styles.disabledInput]: disabled,
  });

  return (
    <div className={styles.container}>
      <div className={classNames(styles.card, containerClass)}>
        {label && <label className={styles.label}>{label}</label>}
        {img && (
          <div className={styles.image}>
            <img src={img} alt="Label" />
          </div>
        )}
        <div className={styles.inputContainer}>
          <input
            type="text"
            value={date}
            onChange={handleChange}
            placeholder={t("MM/YY")}
            maxLength="5"
            disabled={disabled}
            className={inputClass}
          />
        </div>
      </div>
    </div>
  );
}

DateSelect.propTypes = {
  label: PropTypes.string,
  img: PropTypes.string,
  expDate: PropTypes.string,
  onDateChange: PropTypes.func.isRequired,
  isValid: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

export default DateSelect;
